<template>
  <div class="IncrementalData-fieldWrap">
    <div class="IncrementalData-field">
      <p class="IncrementalData-supportingText">
        {{ $lang.diversityQuestions.explainer }}
        <br>
        <a
          target="_blank"
          href="/blog/privacy-policy/"
        >{{ $lang.diversityQuestions.privacyPolicy }}</a>
      </p>
      <div class="IncrementalData-question">
        <div class="Form-field">
          <label
            for="schoolmeal+0"
            class="Form-label font-heavy "
          >Are / were you eligible for free school meals?</label>
          <div
            v-for="(schoolMeals) in freeSchoolMeals"
            :key="schoolMeals.text"
          >
            <rmp-radio
              v-model="fields.free_school_meals"
              :label="schoolMeals.text"
              :value="schoolMeals.value"
              :name="`schoolmeal+${schoolMeals.id}`"
              @change="localValidationMessages.freeSchoolMeals = null"
            />
          </div>
          <error-messages
            :errors="[validateStatus({ field: v$.fields.free_school_meals, serverKey: 'free_school_meals', label: 'Free school meals' })][0]['errors']"
            :manual-validate="validateAll"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import rmpRadio from '@/components/form/radio-button';
import errorMessages from '@/components/form/partials/error-message.vue';
import useVuelidate from '@vuelidate/core';
import incrementalMixin from '../mixins/incremental-data-field-mixin';

export default {

  components: {
    rmpRadio,
    errorMessages,
  },
  mixins: [incrementalMixin],

  data() {
    return {
      v$: useVuelidate(),
      fields: {
        free_school_meals: null,
      },
      fieldName: 'free_school_meals',
      showLocalValidation: false,
      localValidationMessages: [],
    };
  },
  computed: {
    ...mapState('entities', {
      freeSchoolMeals: (state) => state.freeSchoolMeals,
    }),
    updatePayload() {
      return this.fields;
    },
  },
  mounted() {
    this.getFreeSchoolMeals();
  },
  methods: {
    ...mapActions('entities', ['getFreeSchoolMeals']),
  },
};
</script>
